module.exports = __webpack_public_path__ + "img/hiking_1413_5.ca38c6b9.jpg";